import { directiveResolveParams } from '../util';
import flatpickr from "flatpickr";
import { French } from 'flatpickr/dist/l10n/fr.js';
export default {
    // called before bound element's attributes
    // or event listeners are applied
    created(el, binding, vnode, prevVnode) {},
    // called right before the element is inserted into the DOM.
    beforeMount(el, binding, vnode, prevVnode) {},
    // called when the bound element's parent component
    // and all its children are mounted.
    mounted(el, binding, vnode, prevVnode) {
        let inputDate = document.querySelector(directiveResolveParams(el, binding, 'input'));
        let elmDateDisplay = document.querySelector(directiveResolveParams(el, binding, 'display'));
        let btnReset = document.createElement('button');
        btnReset.classList.add('btn', 'btn-sm', 'btn-third', 'btn-reset');
        btnReset.innerHTML = '&nbsp;';

        btnReset.addEventListener('click', function(event){
            event.preventDefault();
            event.stopPropagation();
            if (inputDate) {
                inputDate.value = '';
                inputDate.form.dispatchEvent(new Event('change'));
            }
            if (elmDateDisplay) {
                elmDateDisplay.innerHTML = '';
            }
        });

        flatpickr(el, {
            onChange: (selectedDates, dateStr, instance) => {
                if (inputDate) {
                    inputDate.value = dateStr;
                }
                if (elmDateDisplay) {
                    elmDateDisplay.innerHTML = ' : ' + dateStr;
                    elmDateDisplay.appendChild(btnReset);
                }
            },
            locale: French,
            disableMobile: "true"
        });
    },
    // called before the parent component is updated
    beforeUpdate(el, binding, vnode, prevVnode) {},
    // called after the parent component and
    // all of its children have updated
    updated(el, binding, vnode, prevVnode) {},
    // called before the parent component is unmounted
    beforeUnmount(el, binding, vnode, prevVnode) {},
    // called when the parent component is unmounted
    unmounted(el, binding, vnode, prevVnode) {}
}
